/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetMonitoringCountsAdminResponse } from '../models/GetMonitoringCountsAdminResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MonitoringService {
    /**
     * **Required Policy:** `ViewMonitoring`
     * @returns GetMonitoringCountsAdminResponse OK
     * @throws ApiError
     */
    public static getCountsAdmin({
        regionIds,
        channelIds,
    }: {
        regionIds?: Array<number>,
        channelIds?: Array<number>,
    }): CancelablePromise<GetMonitoringCountsAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/monitoring/counts',
            query: {
                'regionIds': regionIds,
                'channelIds': channelIds,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
